<template>
    <div class="personal-info">
        <div style="height:50px;line-height:50px;padding-left:15px;color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;background:#fff;">个人信息</div>
        <div style="flex:1;overflow-y:auto;padding:16px 24px 24px 16px;">
            <div style="background:#fff;padding:20px 24px;position:relative;max-height:254px;box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04)">
                <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">
                    <span>头像设置</span>
                </div>
                <div style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:8px;">选择一张个人正面照片作为头像，让大家可以更容易认识你</div>
                <div style="margin:20px 0">
                    <img style="height:96px;" :src="basicInfo.avatar" alt="">
                </div>
                <div>
                    <a-upload
                        :multiple="true"
                        :customRequest="customRequest2"
                    >
                        <div>
                            <a-button type="primary">
                            上传头像
                            </a-button>
                        </div>
                    </a-upload>
                </div>
            </div>
            <div class="personal-data">
                <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;margin-bottom:6px">
                    <span>个人资料</span>
                </div>
                <div class="data-item">
                    <span class="item-title">角色：</span>
                    <span class="item-content">{{basicInfo.roleName}}</span>
                </div>
                <div class="data-item">
                    <span class="item-title">上级账号：</span>
                    <span class="item-content">{{basicInfo.superiorNames}}</span>
                </div>
                <div class="data-item">
                    <span class="item-title">姓名：</span>
                    <span v-if="!personalInfoBool" class="item-content">{{basicInfo.name}}</span>
                    <a-input v-model="personalInfoObj.name" v-if="personalInfoBool" class="item-input" placeholder="请输入内容" />
                </div>
                <div class="data-item">
                    <span class="item-title">手机号：</span>
                    <span v-if="!personalInfoBool" class="item-content">{{basicInfo.phone}}</span>
                    <a-input v-model="personalInfoObj.phone" v-if="personalInfoBool" class="item-input" placeholder="请输入内容" />
                </div>
                <div class="data-item">
                    <span class="item-title">邮箱：</span>
                    <span v-if="!personalInfoBool" class="item-content">{{basicInfo.email}}</span>
                    <a-input v-model="personalInfoObj.email" v-if="personalInfoBool" class="item-input" placeholder="请输入内容" />
                </div>
                <div class="data-item">
                    <span class="item-title">微信号：</span>
                    <span v-if="!personalInfoBool" class="item-content">{{basicInfo.wechatNumber}}</span>
                    <a-input v-model="personalInfoObj.wechatNumber" v-if="personalInfoBool" class="item-input" placeholder="请输入内容" />
                </div>
                <div class="data-item" style="height:auto;">
                    <span class="item-title" style="float:left;">微信二维码：</span>
                    <img v-if="!personalInfoBool" style="width:80px;height:80px;" :src="basicInfo.wechatQrcode" alt="">
                    <a-upload
                        v-if="personalInfoBool"
                        :multiple="true"
                        :customRequest="customRequest1"
                    >
                        <div v-if="fileList1.length < 1">
                            <a-button type="primary" icon="plus">
                            上传二维码
                            </a-button>
                        </div>
                        <img style="height:80px;" v-if="fileList1.length > 0" :src="fileList1[0]" alt="">
                    </a-upload>
                </div>
                <div class="data-item" style="margin-top:20px;height:auto;">
                    <span class="item-title"></span>
                    <a-button v-if="personalInfoBool" @click="cancelPersonalInfo" style="margin-right:8px;">
                    取消
                    </a-button>
                    <a-button v-if="personalInfoBool" @click="savePersonalInfo" type="primary">
                    保存
                    </a-button>
                    <a-button v-if="!personalInfoBool" @click="editPersonalInfo" type="primary">
                    编辑
                    </a-button>
                </div>
            </div>
            <div class="password-set">
                <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;">
                    <span>密码设置</span>
                </div>
                <div v-if="!passwordBool" class="data-item">
                    <span class="item-title">密码：</span>
                    <span class="item-input">******</span>
                </div>
                <div v-if="passwordBool" class="data-item">
                    <span class="item-title">旧密码：</span>
                    <a-input v-model="passwordObj.oldPwd" class="item-input" placeholder="请输入内容" />
                </div>
                <div v-if="passwordBool" class="data-item">
                    <span class="item-title">新密码：</span>
                    <a-input v-model="passwordObj.newPwd" class="item-input" placeholder="请输入内容" />
                </div>
                <div v-if="passwordBool" class="data-item">
                    <span class="item-title">确认新密码：</span>
                    <a-input v-model="passwordObj.surePwd" class="item-input" placeholder="请输入内容" />
                </div>
                <div class="data-item" style="margin-top:20px;">
                    <span class="item-title"></span>
                    <a-button v-if="passwordBool" @click="cancelPassword" style="margin-right:8px;">
                    取消
                    </a-button>
                    <a-button v-if="passwordBool" @click="savePassword" type="primary">
                    保存
                    </a-button>
                    <a-button v-if="!passwordBool" @click="editPassword" type="primary">
                    编辑
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PersonalInfo',
        data() {
            return {
                headers: {
                    authorization: 'authorization-text',
                },
                basicInfo: '',
                personalInfoBool: false,
                passwordBool: false,
                passwordObj: {
                    oldPwd: '',
                    newPwd: '',
                    surePwd: '',
                },
                personalInfoObj: {
                    name: '',
                    phone: '',
                    email: '',
                    wechatNumber: '',
                    wechatQrcode: '',
                },
                fileList1: [],
                newFormData1: '',
                newFormData2: '',
            }   
        },
        methods: {
            queryBasicInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.basicInfo = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelPersonalInfo() {
                this.personalInfoBool = false
                this.fileList1 = []
                this.personalInfoObj = {
                    name: '',
                    phone: '',
                    email: '',
                    wechatNumber: '',
                    wechatQrcode: '',
                }
            },
            savePersonalInfo() {
                this.personalInfoBool = false
                this.axios.post('/api/serviceProviderUser/updateUserInfo', {
                    name: this.personalInfoObj.name,
                    phone: this.personalInfoObj.phone,
                    email: this.personalInfoObj.email,
                    wechatNumber: this.personalInfoObj.wechatNumber,
                    wechatQrcode: this.personalInfoObj.wechatQrcode
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryBasicInfo()
                        this.passwordObj = {
                            oldPwd: '',
                            newPwd: '',
                            surePwd: '',
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editPersonalInfo() {
                this.personalInfoBool = true
                this.personalInfoObj.name = this.basicInfo.name
                this.personalInfoObj.phone = this.basicInfo.phone
                this.personalInfoObj.email = this.basicInfo.email
                this.personalInfoObj.wechatNumber = this.basicInfo.wechatNumber
            },
            cancelPassword() {
                this.passwordBool = false
                this.passwordObj = {
                    oldPwd: '',
                    newPwd: '',
                    surePwd: '',
                }
            },
            savePassword() {
                this.passwordBool = false
                this.axios.post('/api/serviceProviderUser/updatePassword', {
                    oldPassword: this.passwordObj.oldPwd,
                    newPassword: this.passwordObj.newPwd,
                    newPasswordConfirm: this.passwordObj.surePwd,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.passwordObj = {
                            oldPwd: '',
                            newPwd: '',
                            surePwd: '',
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editPassword() {
                this.passwordBool = true
            },
            customRequest1(data) {
                this.newFormData1 = ''
                const formData = new FormData() 
                formData.append('file', data.file)
                this.newFormData1 = formData
                this.axios({
                    method: 'post',
                    url: '/api/file/upload',
                    headers:{
                        'Content-Type':'application/x-www-form-urlencoded'
                    },
                    data: this.newFormData1,
                
                }).then((response) => {
                    if(response.data.code == 0){
                        this.newFormData1 = ''
                        this.fileList1 = []
                        this.fileList1.push(response.data.data.filePath)
                        this.personalInfoObj.wechatQrcode = response.data.data.fileId
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            },
            customRequest2(data) {
                this.newFormData2 = ''
                const formData = new FormData() 
                formData.append('file', data.file)
                this.newFormData2 = formData
                this.axios({
                    method: 'post',
                    url: '/api/file/upload',
                    headers:{
                        'Content-Type':'application/x-www-form-urlencoded'
                    },
                    data: this.newFormData2,
                
                }).then((response) => {
                    if(response.data.code == 0){
                        this.newFormData2 = ''
                        this.changeAvatar(response.data.data.fileId)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            },
            changeAvatar(id) {
                this.axios.post('/api/serviceProviderUser/updateAvatar', {
                    avatar: id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryBasicInfo()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }
        },
        mounted: function() {
            this.queryBasicInfo()
        }
    }
</script>

<style scoped lang="less">
    .personal-info{
        height: 100%;
        display: flex;
        flex-direction: column;
        .personal-data{
            background: #fff;
            padding: 20px 24px;
            position: relative;
            max-height: 506px;
            box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04);
            margin: 16px 0;
            position: relative;
            .data-item{
                margin-top: 20px;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                line-height: 28px;
                height: 28px;
                .item-title{
                    display: inline-block;
                    width: 92px;
                    float: left;
                    height: 10px;
                }
                .item-input{
                    width: 416px;
                    border-color: rgba(158, 172, 196, 0.3);
                    color: rgba(158, 172, 196, 1);
                    height: 28px;
                }
                .add-img{
                    height: 28px;
                    color: rgba(158, 172, 196, 1);
                    background: rgba(158, 172, 196, 0.12);
                    font-size: 13px;
                    border: none;
                }
            }
        }
        .password-set{
            background: #fff;
            padding: 20px 24px;
            position: relative;
            max-height: 274px;
            box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04);
            .data-item{
                margin-top: 20px;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                .item-title{
                    display: inline-block;
                    width: 92px;
                }
                .item-input{
                    width: 416px;
                    border-color: rgba(158, 172, 196, 0.3);
                    color: rgba(158, 172, 196, 1);
                }
                .add-img{
                    height: 28px;
                    color: rgba(158, 172, 196, 1);
                    background: rgba(158, 172, 196, 0.12);
                    font-size: 13px;
                    border: none;
                }
            }
        }
    }
</style>